module.exports = __webpack_public_path__ + "static/rs-8d51c4ce5a5173e72dca43067aa9f7bd.svg";